export const PAYROLL = {
  CORPORATIONS: "/v1/corporations",
  WAGE_TYPES: "/v1/PayrollSetup/WageAndPayTypes/List",
  ACCOUNTS: "/v1/accounts",
  ACCOUNT_TYPES: "v1/accounttypes?SortOrderValues=3%2C5%2C6%2C7%2C8%2C9%2C13%2C14%2C15%2C16%2C17%2C18%2C20%2C21%2C22%2C23%2C24%2C25",
  SAVE_ACCOUNT: "/v1/saveaccount",
  JOB_TITLES: "/v1/JobTitle/LoadJobTitleList",
  SAVE_JOB_TITLE: "/v1/JobTitle/SaveJobTitle",
  PAYROLL_SETUP: "/v1/PayrollSetup/SavePayrollSetup",
  DEPARTMENTS: "/v1/JobTitle/LoadDeptList",
  FILTERED_PAYROLL: "/v1/PayrollSetup/GetFilteredPayrollLoad",
  PAYROLL_BY_ID: "/v1/PayrollSetup/PayrollItemDetails/GetById",
  AUDIT_LOG: "/v1/PayrollSetup/LoadAuditLog",
  DELETE_PAYROLL: "/v1/PayrollSetup/DeletePayrollSetup",
  CLONE_PAYROLL: "/v1/PayrollSetup/ClonePayrollSetup",
  IMPORT_PAYROLL: "/v1/PayrollSetup/Import",
  PRIVILEGES: "/v1/Previlages",
};

export const EMPLOYEE = {
  FILTER: "/v1/EmployeeMaster/GetFilteredEmpDetails",
  SAVE: "/v1/EmployeeMaster/SaveEmployee",
  UPDATE: "/v1/EmployeeMaster/UpdateEmployee",
  DELETE: "/v1/EmployeeMaster/DeleteEmployee",
  GET_BY_ID: "/v1/EmployeeMaster/EmployeeDetails/EMPID",
  PAYROLL_DETAILS: "/v1/EmployeeMaster/GetPayrollDetails",


  QUICK_ADD: "/v1/EmployeeMaster/PayrollEmpQuickAdd",
  IMPORT: "/v1/EmployeeMaster/EmployeeImport",
  GET_NAMES: "/v1/EmployeeMaster/LoadEmpName",

  RELATION_LIST: "/v1/EmployeeMaster/LoadRelationList",
  ADD_RELATION: "/v1/EmployeeMaster/SaveRelation",
  BANK_LIST: "/v1/EmployeeMaster/LoadBankList",
  ADD_BANK: "/v1/EmployeeMaster/SaveBank",


  AUDIT: "/v1/EmployeeMaster/EmployeeAudit",


  FREQUENCIES: "/v1/frequencies",
  PROFIT_CENTERS: "/v1/pcs",

  COUNTRIES: "/v1/Country/List",
  STATES: "/v1/States/List",

  FILE_UPLOAD: "/v2/docs/Upload",
  FILES_LIST: "/v2/docs/filesview",
  FILE_DELETE: "/v2/docs/Delete",
  FILE_DOWNLOAD: "/v2/docs/Download",
};

// -------------------------
// Payroll Entry
// -------------------------
export const PAYROLL_ENTRY = {
  SAMPLE_TEMPLATES: "/v2/docs/VendorTemplateDownload",
  FILTER: "/v1/PayrollEntry/Viewgrid",
  SAVE: "/v1/PayrollEntry/SavePayrollEntry",
  UPDATE: "/v1/PayrollEntry/UpdatePayrollEntry",
  DELETE: "/v1/PayrollEntry/DeletePayroll",
  GET_BY_ID: "/v1/PayrollEntry/GetById",
  AUDIT_LOG: "/v1/PayrollEntry/LoadAuditLog",
  IMPORT: "/v1/PayrollEntry/ImportPayroll",

  CACHE_IMPORTED: "/v1/PayrollEntry/CacheImportedPayroll",
  LOAD_PAY_PERIOD: "/v1/PayrollEntry/LoadPayPeriodSetup",
  UPDATE_PAY_PERIOD: "/v1/PayrollEntry/UpdatePayPeriodSetup",
  LOAD_EMP_DETAILS: "/v1/PayrollEntry/LoadEmployeesPayrollDetails",
  GET_EMP_MAPPING: "/v1/PayrollEntry/GetPayrollEmployeeMapping",
  UPDATE_EMP_MAPPING: "/v1/PayrollEntry/UpdatePayrollEmployeeMapping",
  GET_DEPT_JOB: "/v1/PayrollEntry/GetDeptJobDetails",
  VOID_PAYROLL: "/v1/PayrollEntry/PayrollEmpVoid",

  PREVIOUS_PAYROLL_BY_CORP: "/v1/PayrollEntry/PreviousPayrollByCorp",
  LOAD_EMPLOYEES: "/v1/PayrollEntry/LoadEmployees",
  SAVE_PAYROLL_EMPLOYEE: "/v1/PayrollEntry/SavePayrollEmployee",
  GET_PAYROLL_ITEM_NAMES: "/v1/PayrollEntry/GetPayrollItemNames",
  GET_PAYROLL_ITEM_ACC: "/v1/PayrollEntry/GetPayrollItemAccounts",
  SAVE_EDIT_EMPLOYEE: "/v1/PayrollEntry/SaveOrEditPayrollEmpMapping",
  DELETE_EMPLOYEE: "/v1/PayrollEntry/DeletePayrollEmployee",
  VENDOR_TYPE: "/v1/PayrollEntry/LoadPayrollVendorTypes",

  ASK_AI: "/v1/PayrollEntry/LoadAskAISuggestion",
  MULTI_SAVE: "/v1/PayrollEntry/PayrollItemDetailUpdate",

  UNMATCHED_PAYROLLS: "/v1/PayrollEntry/UnmatchedPayroll",
  UNMATCHED_PAYROLL_QUEUE: "/v1/PayrollEntry/UnmatchedPayrollsQueue",

  VENDOR_PREF: "/v1/PayrollEntry/GetPayrollVendorPref",

  GET_PAYROLL_ITEM_TYPE_MAPPING: "/v1/PayrollEntry/GetPayrollItemTypeMapping",
  UPDATE_PAYROLL_ITEM_TYPE_MAPPING: "/v1/PayrollEntry/UpdatePayrollItemTypeMapping",
  GET_PAY_PREFERENCE_ITEM_TYPE_MAPPING: "/v1/PayrollEntry/GetPayPreferenceItemTypeMap"

};


export const PAYROLL_PREFERENCE = {
  GET: "/v1/PayrollConfig/GetPayrollPreferenceDetails",
  SAVE: "/v1/PayrollConfig/SaveOrUpdatePayrollPreference",
  PAYROLL_EMAIL: "/v1/PayrollConfig/GetPayrollEmail"
};

export const UPLOAD = {
  FILE_UPLOAD: "/", // base URL already contains full path
};


export const PAYABLE = {
  DATE_RANGE: "/v1/viewtransactionrangepref",
  BILL_ENTRY_PREF: "/v1/getBillEntryPreferences",
  LOCK_CHECK: "/v1/CorporationLockCheck",
  VALIDATE_PASSWORD: "/v1/ValidatePassword",
};


export const JOBMASTER = {
  JOBMASTER_LIST: "/v1/JobTitle/LoadJobTitleFilterList",
  DELETE_JOB_TITLE: "/v1/JobTitle/DeleteJobTitle"
}

export const LABOUR_CUSTOMIZE = {
  GET_MANAGEMENT_GROUPS_LIST: '/v1/GetManagementGroupsList',
  GET_CORP_AND_PC_LIST: '/v1/DailySale/GetCorpAndPCListByMgntGrpWithPmsBrandSerTypes',
  CORPORATION_DETAILS: '/v1/CorporationDetails',
};

export const PAYROLL_REPORT = {
  TimeandAttendanceReport: '/v1/PayrollReport/TimeandAttendanceReport',
  GetMemorizedTimeAndAttendanceReport: '/v1/PayrollReport/TimeandAttendanceReportMemorizeGetDetails',
  SaveMemorizedTimeAndAttendanceReport: '/v1/PayrollReport/TimeandAttendanceReportMemorizeSaveDetails',
  ResetMemorizedTimeAndAttendanceReport: '/v1/PayrollReport/TimeandAttendanceReportResetDetails',
}